module.exports = __webpack_public_path__ + "img/rights-img.73c6dd37.png";